<template>
    <el-drawer
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body">
                    <el-form ref="detailData" :model="detailData" label-position="top" size="small">
                        <template v-for="(row, index) in detailData.row.products_array">
                            <div :key="index" class="el-drawer___group">
                                <el-form-item
                                    :label="
                                        detailData.row.products_array.length === 1
                                            ? '商品：'
                                            : '商品：' + (index + 1) + ''
                                    "
                                    :prop="'row.products_array.' + index + '.product_id'"
                                    :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                                >
                                    <el-select
                                        v-model="row.product_id"
                                        filterable
                                        clearable
                                        @change="
                                            value => {
                                                ChangeProduct(value, index)
                                            }
                                        "
                                    >
                                        <el-option
                                            :key="product.id"
                                            :label="
                                                product.name +
                                                '' +
                                                (product.barcode
                                                    ? '（' + product.barcode + '）'
                                                    : null)
                                            "
                                            :value="product.id"
                                            v-for="product in productData.list"
                                        >
                                            <span class="el-select-dropdown__item__l"
                                                >{{ product.name
                                                }}{{
                                                    product.barcode
                                                        ? '（' + product.barcode + '）'
                                                        : null
                                                }}</span
                                            >
                                            <span class="el-select-dropdown__item__r">{{
                                                product.classify.name
                                            }}</span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <template v-if="row.product_id">
                                    <el-row :gutter="10">
                                        <el-col :span="12">
                                            <el-form-item
                                                :prop="'row.products_array.' + index + '.unit_id'"
                                                :rules="[
                                                    {
                                                        required: true,
                                                        message: ' ',
                                                        trigger: 'change'
                                                    }
                                                ]"
                                            >
                                                <el-select
                                                    v-model="row.unit_id"
                                                    placeholder="单位"
                                                    @change="
                                                        value => {
                                                            ChangeUnit(value, index)
                                                        }
                                                    "
                                                >
                                                    <el-option
                                                        :key="sku.unit_id"
                                                        :label="sku.unit_label"
                                                        :value="sku.unit_id"
                                                        v-for="sku in row.sku_array"
                                                    >
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col
                                            :span="12"
                                            :prop="'row.products_array.' + index + '.price'"
                                            :rules="[
                                                { required: true, message: ' ', trigger: 'change' }
                                            ]"
                                        >
                                            <el-form-item>
                                                <el-input-number
                                                    v-model="row.price"
                                                    :min="0.0"
                                                    :precision="2"
                                                    :step="0.1"
                                                    controls-position="right"
                                                    placeholder="单价（元）"
                                                ></el-input-number>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </template>
                            </div>
                        </template>
                        <el-form-item v-if="productData.list.length">
                            <el-button
                                type="primary"
                                plain
                                icon="el-icon-circle-plus"
                                @click="AddProduct"
                                >商品</el-button
                            >
                        </el-form-item>
                        <el-form-item
                            label="经营地区："
                            prop="row.area_array"
                            :rules="[{ required: true, message: ' ', trigger: 'change' }]"
                        >
                            <el-cascader
                                v-model="detailData.row.area_array"
                                :options="areaData.list"
                                :props="{ multiple: true, checkStrictly: true }"
                                clearable
                                filterable
                                collapse-tags
                            ></el-cascader>
                        </el-form-item>
                        <template
                            v-if="detailParam.row.customer_type_id == 1 && !detailData.loading.form"
                        >
                            <el-row :gutter="20">
                                <template
                                    v-for="(item, index) in detailData.row.qualification_array"
                                >
                                    <el-col :key="index" :span="6">
                                        <el-form-item :key="index" :label="item.name + '：'">
                                            <el-upload
                                                name="file"
                                                action=""
                                                :data="{ index: index }"
                                                :show-file-list="false"
                                                :http-request="UploadQualification"
                                                class="drawer-upload drawer-upload-small"
                                            >
                                                <template v-if="item.value">
                                                    <el-image
                                                        :src="
                                                            'http://img.hemutx.com/' +
                                                            item.value +
                                                            '?imageView2/1/w/120/h/120/q/100'
                                                        "
                                                        fit="cover"
                                                    ></el-image>
                                                </template>
                                                <template v-else>
                                                    <i slot="default" class="el-icon-plus"></i>
                                                </template>
                                            </el-upload>
                                        </el-form-item>
                                    </el-col>
                                </template>
                            </el-row>
                        </template>
                        <el-form-item label="扶持政策：" prop="row.support">
                            <el-input type="textarea" v-model="detailData.row.support"></el-input>
                        </el-form-item>
                        <el-form-item label="合作约定：" prop="row.agreement">
                            <el-input type="textarea" v-model="detailData.row.agreement"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitlDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { AreaData } from '@/plugin/Area'
import { CustomerData } from '@/plugin/Customer'
export default {
    inject: ['reload'],
    mixins: [AreaData, CustomerData],
    props: ['detailParam'],
    data() {
        return {
            cooperationData: {
                list: []
            },
            productData: {
                used: 0,
                agent: [],
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            detailData: {
                title: '客户合作',
                loading: {
                    main: false,
                    submit: false
                },
                list: [],
                row: {
                    products_array: [
                        {
                            product_id: null,
                            unit_id: null,
                            price: null
                        }
                    ],
                    products: null,
                    area_array: [],
                    area: null,
                    qualification_array: [],
                    qualification: null,
                    support: null,
                    agreement: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetCooperation()
            this.GetProduct()
            this.GetExtend()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    methods: {
        // 上传图片
        UploadQualification(obj) {
            let requestData = new FormData()
            requestData.append('file', obj.file)
            this.$upload({
                data: requestData
            }).then(res => {
                this.detailData.row.qualification_array[obj.data.index].value = res.filePath
            })
        },
        // 查看当地是否有经销
        GetCooperation() {
            this.$request({
                url: '/api/v1/agent_area_check',
                params: {
                    province: this.detailParam.row.province,
                    city: this.detailParam.row.city,
                    county: this.detailParam.row.county
                }
            }).then(res => {
                if (!res.status) {
                    this.cooperationData.list = []
                    res.data.forEach(row => {
                        row.productList.forEach(row => {
                            row.forEach(row => {
                                this.cooperationData.list.push(row.id)
                            })
                        })
                    })
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 商品
        GetProduct() {
            this.detailData.loading.main = true
            this.$request({
                url: '/api/v1/product',
                params: {
                    order_field: 'id',
                    status: 1,
                    ...this.productData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.detailData.loading.main = false
                    res.data.list.forEach(product => {
                        product.sku_array = JSON.parse(product.sku)
                    })
                    this.productData.list = res.data.list
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        // 根据单位设置默认价格
        ChangeUnit(value, index) {
            this.detailData.row.products_array[index].sku_array.forEach(sku => {
                if (sku.unit_id === value) {
                    this.detailData.row.products_array[index].price = sku.price
                }
            })
        },
        // 移除商品
        ChangeProduct(value, index) {
            if (!this.detailData.row.products_array[index].product_id) {
                if (this.detailData.row.products_array.length > 1) {
                    this.detailData.row.products_array.splice(index, 1)
                }
            } else {
                this.detailData.row.products_array[index].unit_id = null
                this.detailData.row.products_array[index].price = null
                this.detailData.row.products_array[index].num = null
                this.productData.list.forEach(product => {
                    if (product.id === value) {
                        this.detailData.row.products_array[index].sku_array = product.sku_array
                    }
                })
            }
        },
        // 增加商品
        AddProduct() {
            this.detailData.row.products_array.push({
                product_id: null,
                unit_id: null,
                price: 0
            })
        },
        // 扩展材料
        GetExtend() {
            this.detailData.row.qualification_array = []
            this.GetLevelData({
                data: {
                    type: 2
                }
            }).then(res => {
                res.list.forEach(row => {
                    this.detailData.row.qualification_array.push({
                        name: row.name,
                        value: null
                    })
                })
            })
        },
        SubmitlDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.detailData.row.products = JSON.stringify(
                        this.detailData.row.products_array
                    )
                    this.detailData.row.area = JSON.stringify(this.detailData.row.area_array)
                    this.detailData.row.qualification = JSON.stringify(
                        this.detailData.row.qualification_array
                    )
                    this.detailData.loading.submit = true
                    this.$request({
                        url: '/api/v1/customer_user_add',
                        params: {
                            ...this.detailParam.row,
                            ...this.detailData.row
                        }
                    }).then(res => {
                        this.detailData.loading.submit = false
                        this.$message({
                            message: res.message || (res.status ? '操作失败' : '操作成功'),
                            type: res.status ? 'error' : 'success'
                        })
                        if (!res.status) {
                            this.reload()
                        }
                    })
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
